<rms-async-select
  [formControl]="control"
  [options]="options"
  [searchable]="true"
  [searchFn]="searchFn"
  [placeholder]="placeholder"
  [loading]="loading"
  [error]="error">
  <ng-template
    #optionTemplate
    let-option>
    <div class="flex items-center gap-1">
      <rms-flag-icon [countryCode]="option.code" />
      <span>[+{{ option.countryCallingCode }}]</span>
      <span>{{ option.name }}</span>
    </div>
  </ng-template>
</rms-async-select>
